export default class User {
  // { id, email, firstname, lastname }
  constructor (data) {
    for (const attribute in data) {
      if (data.hasOwnProperty(attribute)) {
        this['_' + attribute] = data[attribute]
      }
    }
  }
  get (attribute) {
    return this['_' + attribute]
  }
}



// WEBPACK FOOTER //
// ./src/ressources/User.js